import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-3 sm:grid-cols-2" }
const _hoisted_2 = { class: "flex flex-col gap-3" }

import { InputRow } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import TaskTemplateTaskForm from './TaskTemplateTaskForm.vue';
    import { useKeepersEmployeeData } from '@/composables/useKeepersEmployeeData';
    import InputError from '@/components/InputError.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TaskTemplateForm',
  props: {
    form: {}
  },
  setup(__props: any, { expose: __expose }) {

    const { keepersEmployees } = useKeepersEmployeeData();

    const props = __props;

    const addTask = () => {
        props.form.tasks.push({
            name: '',
            description: '',
            weekdays: [],
            status: 'Open',
            responsible_id: '',
            send_notification: 0,
            notification_recurring_week: 0,
            notification_recurring_even_week: 0,
            notification_recurring_start_of_month: 0,
        });
    };

    const removeTask = (index: number) => {
        props.form.tasks.splice(index, 1);
    };

    __expose({
        addTask,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "name",
        label: "task-templates.table.name"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "name",
            modelValue: _ctx.form.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
            placeholder: _ctx.$t('task-templates.table.name')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "description",
        label: "task-templates.table.description"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "description",
            modelValue: _ctx.form.description,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.description) = $event)),
            placeholder: _ctx.$t('task-templates.table.description')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(InputError, {
        message: _ctx.form.errors.tasks
      }, null, 8, ["message"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.tasks, (task, index) => {
        return (_openBlock(), _createBlock(TaskTemplateTaskForm, {
          key: index,
          form: task,
          "main-form": _ctx.form,
          index: index,
          "keepers-employees": _unref(keepersEmployees),
          onRemove: removeTask
        }, null, 8, ["form", "main-form", "index", "keepers-employees"]))
      }), 128))
    ])
  ], 64))
}
}

})